import type { ReactElement } from 'react'

/**
 * Train-car glyphs for the PossibleTransfer strip. Two template shapes
 * exported from the Figma component `RD/PossibleTransfer` (node
 * 6812:14325): `FirstCarGlyph` (rounded front, index 0) and
 * `MiddleCarGlyph` (symmetric, indices 1–4). Both fill with
 * `currentColor` so the strip can tint them text-primary (highlighted)
 * or text-secondary @ 0.4 (dim) — the same template-recolour the iOS
 * `PossibleTransferView` does with `.renderingMode(.template)`.
 *
 * Verbatim Figma paths (34×18 viewBox) so the shape is pixel-identical
 * across iOS / Android / Web (QA spec §3.6).
 */

const SIZE = { width: 34, height: 18 } as const

export function FirstCarGlyph(): ReactElement {
  return (
    <svg viewBox="0 0 34 18" {...SIZE} fill="currentColor" aria-hidden="true" focusable="false">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 0C31.7614 3.86554e-07 34 2.23858 34 5V13C34 15.7614 31.7614 18 29 18H5C2.23858 18 1.28855e-07 15.7614 0 13V9.91211C0.156615 9.96757 0.324384 10 0.5 10H9.5C10.3284 10 11 9.32843 11 8.5V4.5C11 3.67157 10.3284 3 9.5 3H0.5C0.471128 3 0.442531 3.0023 0.414062 3.00391C1.1847 1.23586 2.94813 8.37748e-08 5 0H29ZM14.5 3C13.6716 3 13 3.67157 13 4.5V8.5C13 9.32843 13.6716 10 14.5 10H19.5C20.3284 10 21 9.32843 21 8.5V4.5C21 3.67157 20.3284 3 19.5 3H14.5ZM24.5 3C23.6716 3 23 3.67157 23 4.5V8.5C23 9.32843 23.6716 10 24.5 10H29.5C30.3284 10 31 9.32843 31 8.5V4.5C31 3.67157 30.3284 3 29.5 3H24.5Z"
      />
    </svg>
  )
}

export function MiddleCarGlyph(): ReactElement {
  return (
    <svg viewBox="0 0 34 18" {...SIZE} fill="currentColor" aria-hidden="true" focusable="false">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 0C31.7614 3.86554e-07 34 2.23858 34 5V13C34 15.7614 31.7614 18 29 18H5C2.23858 18 1.28855e-07 15.7614 0 13V5C1.28855e-07 2.23858 2.23858 1.12745e-07 5 0H29ZM4.5 3C3.67157 3 3 3.67157 3 4.5V8.5C3 9.32843 3.67157 10 4.5 10H9.5C10.3284 10 11 9.32843 11 8.5V4.5C11 3.67157 10.3284 3 9.5 3H4.5ZM14.5 3C13.6716 3 13 3.67157 13 4.5V8.5C13 9.32843 13.6716 10 14.5 10H19.5C20.3284 10 21 9.32843 21 8.5V4.5C21 3.67157 20.3284 3 19.5 3H14.5ZM24.5 3C23.6716 3 23 3.67157 23 4.5V8.5C23 9.32843 23.6716 10 24.5 10H29.5C30.3284 10 31 9.32843 31 8.5V4.5C31 3.67157 30.3284 3 29.5 3H24.5Z"
      />
    </svg>
  )
}
